<template>
  <div class="call-request-modal">
    <h3 class="call-request-modal__title">
      {{ title }}
    </h3>

    <form ref="feedbackForm"
      class="call-request-modal__form"
      @submit.prevent="submitForm">
      <input type="hidden" name="form_name" :value="title">
      <FormInput :key="updateKey"
        v-model="form.name"
        class="call-request-modal__input"
        :class="{ _error: invalid && !form.name }"
        name="name"
        placeholder="Ваше ФИО*"
        @blur="onInput" />
      <div class="call-request-modal__row">
        <FormInput :key="updateKey"
          v-model="form.email"
          type="email"
          class="call-request-modal__input"
          name="email"
          placeholder="Ваш email" />
        <FormInput :key="phoneKey"
          v-model="form.phone"
          class="call-request-modal__input"
          type="tel"
          name="phone"
          placeholder="Контактный телефон*"
          :class="{ _error: invalid && !form.phone }"
          @blur="onPhoneInput" />
      </div>
      <div class="call-request-modal__row">
        <FormCheck v-model="formIsCheck"
          :class="{ _error: invalid && !checkIsValid }"
          class="call-request-modal__check"
          @click="onChange">
          Даю согласие на обработку
          <a href="/politika"
            target="_blank">персональных данных </a>
        </FormCheck>
        <AppButton class="call-request-modal__action"
          :to-send="true"
          :sending="sending">
          Отправить
        </AppButton>
      </div>
      <!--   <div v-if="invalid" class="_invalid">Заполните все поля!</div> -->
    </form>
  </div>
</template>

<script>
import FormInput from "@/components/form/FormInput.vue";
import FormCheck from "@/components/form/FormCheck.vue";
import AppButton from "@/components/ui/AppButton.vue";

export default {
  name: "ModalCallRequest",
  components: { FormCheck, FormInput, AppButton },

  props: {
    offer: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Оставить заявку",
    },
    nameIsValid: {
      type: String,
      default: null,
    },
    phoneIsValid: {
      type: String,
      default: null,
    },
    checkIsValid: {
      type: Boolean,
      default: null,
    },
    cardLink: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      form: {
        page: window.location.href,
        message: this.cardLink !== null ? this.cardLink : "",
      },
      invalid: false,
      errors: [],
      formIsCheck: false,
      updateKey: 0,
      phoneKey: 0,
      sending: false,
    };
  },

  methods: {
    isValid() {
      const nameIsValid = !!this.form.name;
      const phoneIsValid = !!this.form.phone;
      const checkIsValid = !!this.formIsCheck;

      if (nameIsValid && phoneIsValid && checkIsValid) return true;
    },

    onChange() {
      this.formIsCheck = !this.formIsCheck;
    },

    onInput(event) {
      const inputValue = event.target.value;
      const inputLength = inputValue.length;

      if (inputLength < 1) {
        this.form.name = null;
      }
    },

    onPhoneInput(event) {
      const inputValue = event.target.value;
      const inputLength = inputValue.length;

      if (inputLength < 18) {
        this.phoneKey += 1;
        this.form.phone = null;
      }
    },

    submitForm() {
      let api;
      this.offer ? (api = "/api/sendFeedback?type=offer") : (api = "/api/sendFeedback?type=request");
      if (this.isValid()) {
        this.errors = [];
        this.invalid = false;
        this.sending = true;
        this.axios
          .post(api, this.form)
          .then((response) => {
            if (response.status) {
              let form = this.form;

              form = {};

              Object.keys(form).forEach(function (key) {
                form[key] = "";
              });

              this.formIsCheck = false;
              this.sending = false;
              this.clearForm();
              this.updateKeyValue();
              this.phoneKey += 1;
              this.form.phone = null;
              this.form.name = null;
              this.$emit("form-success-sent");
            }
          })
          .catch((error) => {
            this.sending = false;
            /* this.errors = error.response.data.errors; */
          });
      } else {
        this.invalid = true;
      }
    },

    clearForm() {
      const form = this.$refs.feedbackForm;
      const formInputs = form.querySelectorAll("._fixed-label");

      form.reset();

      formInputs.forEach((input) => {
        input.classList.remove("_fixed-label");
      });
    },

    updateKeyValue() {
      this.updateKey += 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.call-request-modal {
  $that: &;

  padding: 68px 104px;

  @include tablet {
    padding: 58px;
  }

  @include phone {
    padding: 38px 28px;
  }

  @include phone {
    padding: 28px 16px;
  }

  &__title {
    font-size: 36px;
    line-height: 42px;
    margin-bottom: 42px;

    @include phone {
      font-size: 24px;
      line-height: 120%;
      margin-bottom: 30px;
    }
  }

  &__caption {
    color: #141c1a;
    text-align: center;
    line-height: 24px;
    margin-bottom: 32px;
  }

  &__input+&__row {
    margin-top: 24px;

    @include phone {
      margin-top: 10px;
    }
  }

  &__row {
    display: flex;
    gap: 10px;

    @include phone {
      flex-direction: column;
    }

    &+& {
      margin-top: 24px;

      @include phone {
        margin-top: 10px;
      }
    }

    & * {
      flex: 0 0 50%;
    }

    .button {
      @include phone {
        margin: 0 auto;
        margin-top: 20px;
      }
    }
  }

  &__action {}

  &__check {
    width: 100%;

    & a {
      text-decoration: underline;
    }
  }

  ._invalid {
    color: red;
    padding-top: 8px;
  }
}
</style>
